if (typeof window.BlogSearch === 'undefined') {
	window.BlogSearch = class BlogSearch {
		constructor(container) {
			this.container = container;
			this.input = container.querySelector('.js-blog-search-input');
			this.results = container.querySelector('[data-blog-results]');
			this.loading = container.querySelector('[data-search="loading"]');

			this.originalHTML = this.results ? this.results.innerHTML : '';

			this.cache = new Map();
			this.timer = null;

			this.bindEvents();
			this.bindOutsideClick();
		}

		bindEvents() {
			if (!this.input) return;

			const form = this.input.closest('form');
			if (form) {
				form.addEventListener('submit', (e) => {
					e.preventDefault();
				});
			}

			const closeButton = this.container.querySelector('.js-catalog-search-close');
			if (closeButton) {
				closeButton.addEventListener('click', (e) => {
					e.preventDefault();
					this.input.value = '';
					clearTimeout(this.timer);
					this.restoreOriginal();
				});
			}

			this.input.addEventListener('input', () => {
				clearTimeout(this.timer);

				this.timer = setTimeout(() => {
					const value = this.input.value.trim();
					if (!value) {
						this.restoreOriginal();
						return;
					}

					this.search(value);
				}, 300);
			});
		}

		bindOutsideClick() {
			document.addEventListener('click', (e) => {
				if (this.input && this.input.contains(e.target)) return;

				if (e.target.closest('.catalog-subcategory')) return;
				if (customElements.get('infinite-pagination') && e.target.closest('infinite-pagination')) return;

				if (e.target.closest('.pagination')) return;

				if (this.input) {
					this.input.value = '';
				}

				this.restoreOriginal();
			});
		}

		showLoading() {
			if (this.loading) this.loading.classList.remove('hidden');
			if (this.results) this.results.classList.add('hidden');
		}

		hideLoading() {
			if (this.loading) this.loading.classList.add('hidden');
			if (this.results) this.results.classList.remove('hidden');
		}

		restoreOriginal() {
			if (!this.results) return;

			this.results.innerHTML = this.originalHTML;
			this.hideLoading();

			document.dispatchEvent(new Event('blog-pagination:reset'));
		}

		async search(term) {
			const key = term.toLowerCase();

			this.showLoading();

			if (this.cache.has(key)) {
				this.results.innerHTML = this.cache.get(key);
				this.hideLoading();
				document.dispatchEvent(new Event('blog-pagination:reset'));
				return;
			}

			const isArabic = document.documentElement.getAttribute('lang') === 'ar';

			const routes = window.routes || {};
			let url;
			let params;

			if (isArabic) {
				url = routes.search_url || '/search';
				params = new URLSearchParams({
					q: term,
					type: 'article',
					section_id: 'articles-search-results'
				});
			} else {
				url = routes.predictive_search_url || '/search/suggest';
				params = new URLSearchParams({
					q: term,
					section_id: 'articles-search-results',
					'resources[type]': 'article',
					'resources[limit]': '40'
				});
			}

			try {
				const res = await fetch(`${url}?${params}`);

				if (!res.ok) {
					throw new Error(`Search request failed: ${res.status}`);
				}

				const html = await res.text();
				this.cache.set(key, html);
				if (this.results) this.results.innerHTML = html;

			} catch (e) {
				console.error('Blog search failed', e);
			} finally {
				this.hideLoading();
				document.dispatchEvent(new Event('blog-pagination:reset'));
			}
		}
	};
}

if (typeof window.BlogPagination === 'undefined') {
	window.BlogPagination = class BlogPagination {
		constructor(container) {
			this.container = container;
			this.sectionId = container.dataset.section || container.getAttribute("data-section");

			this.currentPage = this.getInitialPage();

			if (typeof window.PaginationController !== 'undefined') {
				this.pagination = new window.PaginationController({
					paginationSectionId: 'blog-pagination',
					contentSectionId: this.sectionId,

					containerSelector: '[data-article-list]',
					sourceSelector: '[data-article-list]',

					getCurrentPage: () => this.currentPage,
					getTotalPages: () => {
						const p = document.querySelector('.pagination');
						return p ? +p.dataset.totalPages : 1;
					},

					onPageChange: async (page, { append }) => {
						this.currentPage = page;
						if (this.pagination.freezeLayout) this.pagination.freezeLayout();
						await this.pagination.loadPage(page, { append });
						if (this.pagination.unfreezeLayout) this.pagination.unfreezeLayout();
					}
				});
			} else {
				console.warn('PaginationController class is missing or not loaded yet.');
			}
		}

		getTotalPages() {
			const pagination = document.querySelector('.pagination');
			return pagination ? parseInt(pagination.dataset.totalPages) : 1;
		}

		getInitialPage() {
			const activeLink = document.querySelector('.pagination-list a.active');
			if (activeLink) {
				const activePage = parseInt(activeLink.textContent.trim(), 10);
				if (!isNaN(activePage) && activePage > 0) return activePage;
			}

			const pagination = document.querySelector('.pagination');
			const dataPage = pagination ? parseInt(pagination.dataset.currentPage, 10) : NaN;
			if (!isNaN(dataPage) && dataPage > 0) return dataPage;

			return 1;
		}
	};
}

window.initBlogComponents = function() {
	const container = document.querySelector('[data-blog-search-wrapper]');
	if (!container) return;
	if (container.dataset.blogInitialized === 'true') return;

	if (window.BlogSearch) new window.BlogSearch(container);
	if (window.BlogPagination) new window.BlogPagination(container);

	container.dataset.blogInitialized = 'true';
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', window.initBlogComponents);
} else {
	window.initBlogComponents();
}